import classname from 'classnames'
import { assetUrl } from '@/utils/asset-url'

const SelectorBox = ({ active, disabled, label, image, submit }) => {

	const selectorClass = classname({
		'selector-box-3': true,
		'selector-box-3--active': active,
		'selector-box--disabled': disabled
	})

	return (
		<div className={selectorClass} onClick={submit ? submit : null}>
			<div className="selector-box__left">
				{image && (<div className="selector-box__avatar" style={{ backgroundImage: `url(${image})` }}></div>)}
				<div className="selector-box__label">{label}</div>
			</div>
			{
				!disabled && (
					<div className="selector-box__right">
				<div className="selector-box-3__circle-wrap">
                  <div className="selector-box-3__circle"></div>
                </div>
			</div>
				)
			}
		</div>
	)
}

export default SelectorBox
